// src/components/TopBar.jsx
import React from "react";
import "./TopBar.css";
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";

const TopBar = () => {
  return (
    <div className="topbar">
      <div className="topbar-left">
        <a href="https://www.facebook.com/share/1DrKaGpz5c/" target="_blank" rel="noreferrer"><FaFacebookF /></a>
        <a href="https://x.com/tamilmanam8624?t=Lf_ViqY94Cda0asMUzNZDA&s=09 " target="_blank" rel="noreferrer"><FaTwitter /></a>
        <a href="https://www.instagram.com/tamilmanamalai?utm_source=qr&igsh=ZW54bzk3cmZhZXE3" target="_blank" rel="noreferrer"><FaInstagram /></a>
        <a href="https://www.youtube.com/@TamilManamalai" target="_blank" rel="noreferrer"><FaYoutube /></a>
      </div>

      <div className="topbar-right">
        <a href="mailto:tamilmanamalaitrust@gmail.com">
          📧 tamilmanamalaitrust@gmail.com
        </a>
        <a
          href="https://wa.me/919976227686"
          target="_blank"
          rel="noreferrer"
        >
          📞 +91 99769 92375
        </a>
      </div>
    </div>
  );
};

export default TopBar;
